import { experienceApiClient } from '@/config/httpClients';
import type { NewDevelopmentCharge } from './schemas';
import { FeaturesResponseSchema } from './schemas';

const getNewDevelopmentCharge = async (): Promise<NewDevelopmentCharge> => {
  const response = await experienceApiClient
    .get(
      'v1/product-catalog/features?filter[brand]=EXETEL&filter[name]=NEW_DEVELOPMENT_CHARGE'
    )
    .json<{ data: NewDevelopmentCharge[] }>();
  if (!FeaturesResponseSchema.safeParse(response.data).success) {
    //TODO: Log error to Sentry
    console.log('New development charge response validation error');
  }
  //NOTE: There should only be one new development charge, so we return the first one
  return response.data[0];
};

export { getNewDevelopmentCharge };
